import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {CreateSmsBroadcast as CreateSmsBroadcastMutation} from 'nutshell-graphql-types';

import CREATE_SMS_BROADCAST from '../mutations/create-sms-broadcast.graphql';

export function useCreateSmsBroadcast(): {
    createBroadcast: () => Promise<any>;
    isCreating: boolean;
    error: string | null | undefined;
} {
    const [createBroadcast, {loading, error}] = useMutation<
        CreateSmsBroadcastMutation,
        Record<any, any>
    >(CREATE_SMS_BROADCAST);

    return {
        createBroadcast: () => createBroadcast(),
        isCreating: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
